module.exports = __webpack_public_path__ + "media/images/course/certificado_bg-0a7953f86b5a60448a11523f0d7867f6.png";